<template>
  <el-container direction="vertical" style="height: 100%;">
    <el-tabs v-model="selectedTab" @tab-click="handleClick(selectedTab)">
      <el-tab-pane v-for="it in tabList" :key="it.id" :label="it.title" :name="it.url" />
    </el-tabs>
    <div class="tabContent">
      <router-view />
    </div>
  </el-container>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      selectedTab: '',
      tabList: []
    }
  },

  mounted () { 
    this.tabList = this.$route.params.childrenList
    this.selectedTab = this.tabList[0].url
    this.handleClick(this.selectedTab)
  },

  methods: {
    handleClick (url) {
      this.$router.push(`/records/${url}`)
    }
  }
}
</script>
